export const uploadLogoToCloud = async (logo) => {
  try {
    const formData = new FormData();
    formData.append('file', logo);
    formData.append('upload_preset', 'cdmfhl7w');

    const response = await fetch(`https://api.cloudinary.com/v1_1/marmin-seller-logo/image/upload`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    return data?.secure_url || '';
  } catch (err) {
    console.error('Cloudinary upload error:', err);
    return '';
  }
};
